import { UnstyledButton } from './UnstyledButton';

// TODO: in v9, move styled() from UnstyledButton.jsx to here
export var StyledUnstyledButton = UnstyledButton;